// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary{color:#c81919}.social--media-wrapper{margin-top:0;margin-bottom:36px}@media only screen and (max-width: 768px){.social--media-wrapper{margin-bottom:16px}}.social--media-wrapper .input--wrapper{padding:20px 28px 20px 55px}@media only screen and (max-width: 768px){.social--media-wrapper .input--wrapper{padding:8px 0}}", ""]);
// Exports
module.exports = exports;
